import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';
import RestaurantCategoryService from '@/shared/services/restaurant-category.service';
import RestaurantService from '@/shared/services/restaurant.service';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { IRestaurants, SortByTypes } from './types';

const restaurantService = new RestaurantService();
const restaurantCategoryService = new RestaurantCategoryService();

export const actions: ActionTree<IRestaurants, RootState> = {
  retrieveRestaurants({ commit }, postal_code: string): Promise<boolean> {
    return new Promise(resolve => {
      restaurantService.retrievePublic(postal_code).then(restaurantsList => {
        if (restaurantsList.data.length > 0) {
          commit('retrieveRestaurants', restaurantsList.data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },

  async retrieveRestaurantCategories({ commit }) {
    const restaurantCategories = await restaurantCategoryService.retrievePublic();
    commit('retrieveRestaurantCategories', restaurantCategories.data);
  },

  setSelectedCategory({ commit }, newSelectedCategory: IRestaurantCategory): void {
    commit('setSelectedCategory', newSelectedCategory);
  },

  setTypes_deliver({ commit, state }, newDeliver: boolean): void {
    (newDeliver || state.types.pickup) && commit('setTypes_deliver', newDeliver);
  },
  setTypes_pickup({ commit, state }, newPickup: boolean): void {
    (newPickup || state.types.deliver) && commit('setTypes_pickup', newPickup);
  },

  setRatings({ commit }, newRatings: number): void {
    commit('setRatings', newRatings);
  },

  setCosts_free({ state, commit }, newFree: boolean): void {
    if (!state.costs.free) {
      commit('setCosts_free', newFree);
      commit('setCosts_all', false);
    }
  },
  setCosts_all({ state, commit }, newAll: boolean): void {
    if (!state.costs.all) {
      commit('setCosts_all', newAll);
      commit('setCosts_free', false);
    }
  },

  setMinDeliveries_noPreference({ state, commit }, newNoPreference: boolean): void {
    if (!state.minDeliveries.noPreference) {
      commit('setMinDeliveries_noPreference', newNoPreference);
      commit('setMinDeliveries_all', false);
    }
  },
  setMinDeliveries_all({ state, commit }, newAll: boolean): void {
    if (!state.minDeliveries.all) {
      commit('setMinDeliveries_all', newAll);
      commit('setMinDeliveries_noPreference', false);
    }
  },

  setSortBy({ commit }, newSortBy: SortByTypes): void {
    commit('setSortBy', newSortBy);
  },
  setSearch({ commit }, newSearch: string): void {
    commit('setSearch', newSearch);
  },
};
